import { fetchApiData,updateApiData } from "../../../utils/utils";

export const getAccountDetails= async (appInfo) => {
    const api="account/details";
    return await fetchApiData(appInfo,api)
}

export const updateAccountdetails = async (appInfo,values) => {
    
    const api="user/update";
    const location = {
        path:"accountUpdate",
        values
    }
    return await updateApiData(appInfo,api,location)
   
}

export const updateNewsLetter = async (appInfo,flag,email) => {
    const api =`account/newsletter/${flag === true ? 'subscribe':'unsubscribe'}`;
    const data={
        email:email
    }
    const location = {
        path:'common',
        values:data
    }
    return await updateApiData(appInfo,api,location)

}

export const unsubscribe = async (appInfo,subId) => {
  const userId = localStorage.getItem("userId");
  const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
  const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id:subId,
        userid:userId,
        country_code:countryCode,
        pubid:pubId
    }
    const location = {
        path:"common",
        values:data
    }
    const api ="subscription/cancel"
    return await updateApiData(appInfo,api,location)
}

export const pauseSubscription = async (appInfo, subId, pauseDuration) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId,
        pauseForMonths: pauseDuration
    }
    const location = {
        path: "common",
        values: data
    }
    const api = "subscription/pause"
    return await updateApiData(appInfo, api, location)
}

export const resumeSubscription = async (appInfo, subId) => {
    const userId = localStorage.getItem("userId");
    const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
    const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;

    const data = {
        sub_id: subId,
        userid: userId,
        country_code: countryCode,
        pubid: pubId
    }
    const location = {
        path: "common",
        values: data
    }
    const api = "subscription/resume"
    return await updateApiData(appInfo, api, location)
}

export const fetchSubscriptionHistory = async (appInfo) => {
    const api = "subscription/history"
    return await fetchApiData(appInfo,api)
}

export const fetchRecentStreamingDevices = async (appInfo) => {
    const api = "account/devices"
    return await fetchApiData(appInfo,api)
}

export const updatePassword = async (appInfo,values) => {
    const api="user/update";
    const location = {
        path:"accountUpdate",
        values
    }
    return await updateApiData(appInfo,api,location)
}